
import routerLink from '~/router-link'
import SectionTitle from '~/sections/vision/section-title.vue'

export default {
  name: 'VisionProgram',
  components: {
    SectionTitle
  },
  data() {
    return {
      routerLink
    }
  }
}
